<template>
  <input
    type="text"
    class="fts-input-mask fts-form-control"
    autocomplete="input-mask"
    v-model="model"
    @input="$emit('input')"
    @blur="$emit('blur')"
    @focus="$emit('unmask')"
  >
</template>

<script>
export default {
  props: {
    masked: Boolean,
    maskText: {
      default: '**********',
    },
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  computed: {
    model: {
      get() {
        return this.masked ? this.maskText : this.value;
      },
      set(val) {
        if (!this.masked) {
          this.$emit('updateValue', val);
        }
      }
    }
  }
}
</script>